import { useParams } from 'react-router-dom';

import { useAccount } from '@contexts/AccountProvider';
import useGetLimits from '@hooks/queries/useGetLimits';
import LimitOverviewPanel from '@pages/limits/LimitOverviewPanel';

const OverviewLimitContainer = () => {
    const { accountId } = useParams();
    const { program } = useAccount();

    const { data: limits, isLoading: limitsLoading } = useGetLimits(+accountId);

    return (
        <LimitOverviewPanel
            limits={limits}
            isLoading={limitsLoading}
            currencyCode={program?.currency_numeric_code}
        />
    );
};

export default OverviewLimitContainer;
